module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vux-loader 实现方式")]), _vm._v(" "), _c('p', [_vm._v("说明一下"), _c('code', [_vm._v("vux-loader")]), _vm._v("是如何和"), _c('code', [_vm._v("vue-loader")]), _c('del', [_vm._v("搞基")]), _vm._v("配合的。")]), _vm._v(" "), _c('p', [_vm._v("如果你看过"), _c('code', [_vm._v("webpack")]), _vm._v("loader的介绍，理论上说如果需要自己手动先处理代码再传入"), _c('code', [_vm._v("vue-loader")]), _vm._v(",你只需要这样对loader做配置: "), _c('code', [_vm._v("vue-loader!my-loader")]), _vm._v("。但是如果你试过，就知道这个目前行不通。"), _c('code', [_vm._v("vue-loader")]), _vm._v("不会接收上一个loader的source进行处理，因为.vue文件的特殊性，它直接生成了loader string进入下一个处理，处理后的结果大概是这样的：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* styles */")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!vue-style-loader!css-loader!vue-loader/lib/style-rewriter?id=data-v-20d7ba9a!vue-loader/lib/selector?type=styles&index=0!./index.vue\"")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* script */")]), _vm._v("\n__vue_exports__ = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!babel-loader!vue-loader/lib/selector?type=script&index=0!./index.vue\"")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* template */")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("var")]), _vm._v(" __vue_template__ = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!vue-loader/lib/template-compiler?id=data-v-20d7ba9a!vue-loader/lib/selector?type=template&index=0!./index.vue\"")]), _vm._v(")\n")])]), _vm._v(" "), _c('p', [_vm._v("那么vue-loader提供了自定义loader string的选项，直接配置可否呢，"), _c('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue-loader/issues/531"
    }
  }, [_vm._v("#531")]), _vm._v("，直接配置会破坏原来的loader参数，导致不能Live reload。")]), _vm._v(" "), _c('p', [_vm._v("那么最终能想到的就是直接修改"), _c('code', [_vm._v("vue-loader")]), _vm._v("生成的代码，这样既不会影响"), _c('code', [_vm._v("vue-loader")]), _vm._v("原来的逻辑，也能自由控制。")]), _vm._v(" "), _c('p', [_vm._v("最终实现方式是前置"), _c('code', [_vm._v("vux-loader")]), _vm._v("即："), _c('code', [_vm._v("vux-loader!vue-loader")]), _vm._v("，vux-loader将vue-loader生成的代码二次处理，分割loader string并(强行)插入vux的 template-loader, style-loader, script-loader，那么你就能理解vux-loader的配置方式了，在3大基本loader里获取到vux-loader的插件配置列表逐个做处理就行了。")]), _vm._v(" "), _c('p', [_vm._v("上面的代码强行处理后是这样的：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* styles */")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!vue-style-loader!css-loader!vue-loader/lib/style-rewriter?id=data-v-20d7ba9a!./../../../../vux-loader/src/style-loader.js!vue-loader/lib/selector?type=styles&index=0!./index.vue\"")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* script */")]), _vm._v("\n__vue_exports__ = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!babel-loader!vue-loader/lib/selector?type=script&index=0!./../../../../vux-loader/src/script-loader.js!./index.vue\"")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* template */")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("var")]), _vm._v(" __vue_template__ = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!vue-loader/lib/template-compiler?id=data-v-20d7ba9a!./../../../../vux-loader/src/template-loader.js!vue-loader/lib/selector?type=template&index=0!./index.vue\"")]), _vm._v(")\n")])]), _vm._v(" "), _c('p', [_vm._v("原理就是这么简单（但是处理时还是遇到一些问题），为了方便使用，编写了常用的一些插件。")]), _vm._v(" "), _c('p', [_vm._v("至于"), _c('code', [_vm._v("js-parser")]), _vm._v("就只是在"), _c('code', [_vm._v("babel-loader")]), _vm._v("前加上了"), _c('code', [_vm._v("vux-loader")]), _vm._v("的"), _c('code', [_vm._v("js-loader")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("而所有的loader, plugins设置都是在"), _c('code', [_vm._v("vux-loader")]), _vm._v("的"), _c('code', [_vm._v("merge")]), _vm._v("方法里来完成。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-128735aa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-128735aa"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/how-vux-loader-works-314.vue
// module id = 2041
// module chunks = 436